import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Select } from '@backstage/core-components';
import { ACCOUNT_USAGE_OPTIONS } from '../const';
import { AccountUsageType } from '../types';

interface AccountUsageFieldProps {
  selectedValue: string;
  onChange: (value: AccountUsageType) => void;
  error?: boolean;
  errorMessage?: string;
}

export const AccountUsageField = ({
  selectedValue,
  onChange,
  error,
  errorMessage,
}: AccountUsageFieldProps) => (
  <FormControl
    margin="normal"
    required
    error={error}
    fullWidth
  >
    <Select
      label="Account Usage"
      selected={selectedValue}
      items={ACCOUNT_USAGE_OPTIONS}
      onChange={(e) => {
        const value = e as string;
        const accountUsage = Object.values(AccountUsageType).find(type => type === value) as AccountUsageType;
        if (accountUsage) {
          onChange(accountUsage);
        }
      }}
    />
    <FormHelperText error={false}>
      Select how this account will be used. This determines the access permissions and organizational unit assignment.
    </FormHelperText>
    {errorMessage && (
      <FormHelperText error>{errorMessage}</FormHelperText>
    )}
  </FormControl>
); 